import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";
import { grey, red } from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";
function BadgeLabel({
  title,
  colorType,
  onClick,
  margin,
  isDeleteAction = false,
  isLarge = false,
  tip
}: Readonly<{
  title: string;
  colorType: DamsLabelColorType;
  onClick?: () => void;
  margin?: number;
  isDeleteAction?: boolean;
  isLarge?: boolean;
  tip?:string
}>) {
  const colors = DamsLabelColors[colorType];

  return (
        <Tooltip title={tip} arrow  >
    <Box
      display="inline-flex"
      alignItems="center"
      paddingX={isDeleteAction ? 2 :isLarge?2: 1}
      paddingY={isDeleteAction ? 1 :isLarge?1: 0}
      border={`1px solid ${colors.border}`}
      alignContent={"center"}
      borderRadius={16}
      bgcolor={colors.background}
      margin={margin}
      position="relative"
      sx={{
        "&:hover .highlight-text": {
          transition:
            "opacity 0.4s ease-in-out 0.2s, visibility 0s linear 0.2s",
          visibility: "visible",
          opacity: 1
        }
      }}
    >
      {!isDeleteAction ? (
        <IconButton sx={{padding:0}} onClick={onClick}>
        <Typography
          fontFamily={"Inter"}
          fontWeight={500}
          fontSize={12}
          color={colors.text}
        >
          {title}
        </Typography>
        </IconButton>
  
      ) : (
        <Typography
        fontFamily={"Inter"}
        fontWeight={500}
        fontSize={12}
        color={colors.text}
      >
        {title}
        <IconButton
          onClick={onClick}
          className="highlight-text"
          sx={styles.deleteAction}
        >
          <CloseIcon sx={{ width: 15, height: 15 }} />
        </IconButton>
      </Typography>
  
      )}
    </Box>
    </Tooltip>
  );
}

const styles = {
  deleteAction: {
    position: "absolute",
    marginTop: -1.6,
    right: 0,
    marginRight: -0.8,
    opacity: 0,
    display: "inline-flex",
    padding: 1,
    backgroundColor: red[900],
    color: grey[100],
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    "&:hover": {
      backgroundColor: "red"
    }
  }
};

type DamsLabelColorType =
  | "red"
  | "green"
  | "blue"
  | "yellow"
  | "grey"
  | "orange";

const DamsLabelColors: Record<
  DamsLabelColorType,
  { border: string; background: string; text: string }
> = {
  red: {
    border: DamsColors.Badge.Red.border,
    background: DamsColors.Badge.Red.background,
    text: DamsColors.Badge.Red.text
  },

  yellow: {
    border: DamsColors.Badge.Yellow.border,
    background: DamsColors.Badge.Yellow.background,
    text: DamsColors.Badge.Yellow.text
  },

  blue: {
    border: DamsColors.Badge.Blue.border,
    background: DamsColors.Badge.Blue.background,
    text: DamsColors.Badge.Blue.text
  },

  green: {
    border: DamsColors.Badge.Green.border,
    background: DamsColors.Badge.Green.background,
    text: DamsColors.Badge.Green.text
  },

  grey: {
    border: DamsColors.Badge.Grey.border,
    background: DamsColors.Badge.Grey.background,
    text: DamsColors.Badge.Grey.text
  },

  orange: {
    border: DamsColors.Badge.Orange.border,
    background: DamsColors.Badge.Orange.background,
    text: DamsColors.Badge.Orange.text
  }
};

export { BadgeLabel };
